import { render } from "./Alergeno.vue?vue&type=template&id=053deb6a&scoped=true"
import script from "./Alergeno.vue?vue&type=script&lang=js"
export * from "./Alergeno.vue?vue&type=script&lang=js"

import "./Alergeno.vue?vue&type=style&index=0&id=053deb6a&lang=scss&scoped=true"

import exportComponent from "/var/www/clients/client1/web6/web/cartamovil-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-053deb6a"]])

export default __exports__